import { styled } from "@l2r-front/l2r-ui"

export const Container = styled("div")(() => ({
    width: "100%",
    textAlign: "center",
}))